
webpack.register(
    'components/live-tv-schedule/live-tv-schedule',
    function() {
        return require('components/live-tv-schedule/live-tv-schedule');
    },
    false
);
webpack.register(
    'components/broadcaster-search/broadcaster-search',
    function() {
        return require('components/broadcaster-search/broadcaster-search');
    },
    false
);
webpack.register(
    'components/viewing-schedule-tabs/viewing-schedule-tabs',
    function() {
        return require('components/viewing-schedule-tabs/viewing-schedule-tabs');
    },
    false
);
webpack.register(
    'components/video-landing/live-streaming-schedule/live-streaming-schedule',
    function() {
        return require('components/video-landing/live-streaming-schedule/live-streaming-schedule');
    },
    false
);
var stache = require('can/view/stache/stache');
module.exports = stache("<can-import from='components/live-tv-schedule/live-tv-schedule'/>\r\n<can-import from='components/broadcaster-search/broadcaster-search'/>\r\n<can-import from='components/viewing-schedule-tabs/viewing-schedule-tabs'/>\r\n<can-import from='components/video-landing/live-streaming-schedule/live-streaming-schedule'/>\r\n\r\n<div class=\"c-viewing-schedule\">\r\n  <viewing-schedule-tabs {(schedule-date)}=\"scheduleDate\"/>\r\n  <div class=\"s-content\">\r\n    <live-tv-schedule {schedule-date}=\"scheduleDate\"/>\r\n    <broadcaster-search {schedule-date}=\"scheduleDate\"/>\r\n    {{#if scheduleDate}}\r\n      <live-streaming-schedule {schedule-date}=\"scheduleDate\"/>\r\n    {{/if}}\r\n  </div>\r\n</div>");